"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_RUNTIME_BUDGETS = void 0;
const database_identity_1 = require("@streamlain/database-identity");
const app_base_bridge_budgets_1 = require("./app-base-bridge-budgets");
const app_base_contract_1 = require("./app-base-contract");
/**
 * The limits of the platform an App reads through `describe().budgets`, the
 * same on every host: the rows and files of an App (APP_BASE_BUDGETS), the
 * reads of the page (APP_BASE_BRIDGE_BUDGETS) and the size of each cell
 * (DATABASE_LARGE_DATA_POLICY). The host hands them to the core; the App
 * runtime bundle never imports this module.
 */
exports.APP_RUNTIME_BUDGETS = {
    dataset: app_base_contract_1.APP_BASE_BUDGETS,
    bridge: app_base_bridge_budgets_1.APP_BASE_BRIDGE_BUDGETS,
    cells: database_identity_1.DATABASE_LARGE_DATA_POLICY.cell.limits,
};
